export enum TypeQr {
  Basic = "Basic",
  Advanced = "Advanced",
}

export enum OptionAdvancedQr {
  rounded = "rounded",
  dots = "dots",
  classy = "classy",
  classyRounded = "classy-rounded",
  square = "square",
  extraRounded = "extra-rounded",
}

export const TypeQrData = [
  {
    key: "Basic",
    value: "Basic",
  },
  {
    key: "Advanced",
    value: "Advanced",
  },
];

export const OptionAdvancedQrData = [
  {
    key: "rounded",
    value: "rounded",
  },
  {
    key: "dots",
    value: "dots",
  },
  {
    key: "classy",
    value: "classy",
  },
  {
    key: "classyRounded",
    value: "classy-rounded",
  },
  {
    key: "square",
    value: "square",
  },
  {
    key: "extraRounded",
    value: "extra-rounded",
  },
];
